<script>

    // ref: https://github.com/eddiemf/vue-affix
    // ref: https://laurentperrier.ca/sticky-sidebar-with-vuejs
    // ref: https://www.npmjs.com/package/vue-sticky-directive

    import formatMoney from '../utilities/formatMoney';

    export default {
        name: 'infoPane',

        props: {
            sidebarElementId: null,
            isTuitionReady: null,
            isTotalEstimateReady: null,
            selectedDegree: null,
            schoolId: null,
            housingTotal: null,
            info: null,
            discount: null,
            discountMsg: null,
            total: null,
            year: null,
            term: null,
            termsMap: null,
            tuition: null,
            disclaimer: null,
        },

        data() {
            return {
                sidebarEl: null,
                movedEl: null,
                sidebarWrapper: null
            }
        },

        computed: {
            fees: function() {
                return this.info.filter( (i) => i.section === 'fees' );
            },
            expenses: function() {
                return this.info.filter( (i) => i.section === 'expenses' );
            },
            meals: function() {
                return this.info.find( (i) => i.section === 'meals' );
            },
            degreeFees: function() {
                return this.info.filter( (i) => i.section === 'degree-fees' );
            },
            totalMessage: function() {
                if ( this.isTotalEstimateReady && this.total ) {
                    return "<p class='tf-infoPane__total'>" + this.formatMoney(this.total) + "</p>";
                } else {
                    return "<p class='tf-infoPane__incomplete'>Please finish making selections to see a total.</p>";
                }
            }
        },

        methods: {
            formatMoney
        },

        mounted() {

            this.sidebarEl = document.getElementById(this.sidebarElementId);

            // move panel into sidebar
            this.movedEl = this.$el.querySelector('.tf-infoPane');
            this.sidebarEl.appendChild(this.movedEl);

            this.sidebarWrapper = this.sidebarEl.closest('.columns');
            this.sidebarWrapper.classList.add('tf-stickySidebar');


        },

        beforeDestroy() {

            this.sidebarEl.removeChild(this.movedEl);

            this.sidebarWrapper.classList.remove('tf-stickySidebar');

        }

    }
</script>

<template>
    <div class="tf-infoPaneWrapper" >
        <div class="tf-infoPane" >

            <div class="tf-infoPane__header">
                <div class="tf-infoPane__term">{{ termsMap[term].label }}</div>
                <div class="tf-infoPane__acadYear">Academic {{ year }}</div>
            </div>

            <h5>Tuition</h5>
            <div v-if="isTuitionReady">
                <p class="tf-infoPane__degree">Degree: <span>{{ selectedDegree.fullname }}</span></p>
                <p>Tuition: <span class="tf-infoPane__amount">{{ tuition | toCurrency }}</span></p>
                <div v-if="degreeFees.length">
                    <p v-for="i in degreeFees" :key="i.id">{{ i.label }}: <span class="tf-infoPane__amount">{{ i.value | toCurrency }}</span></p>
                </div>
            </div>
            <div v-else>
                <p class="tf-infoPane__incomplete">Please select a degree and respond to any related questions.</p>
            </div>

            <h5>Fees</h5>
            <div v-if="fees.length">
                <p v-for="i in fees" :key="i.id">{{ i.label }}: <span class="tf-infoPane__amount">{{ i.value | toCurrency }}</span></p>
            </div>
            <div v-else>
                <p class="tf-infoPane__incomplete">Please complete Step 1.</p>
            </div>

            <h5 v-if="housingTotal">Housing</h5>
            <div v-if="housingTotal">
                <p>Housing <span class="tf-infoPane__amount">{{ housingTotal | toCurrency }}</span></p>
            </div>

            <h5>Meals</h5>
            <div v-if="meals">
                <p>{{ meals.label }} <span class="tf-infoPane__amount">{{ meals.value | toCurrency }}</span></p>
            </div>
            <div v-else>
                <p class="tf-infoPane__incomplete">Please select a meal plan.</p>
            </div>

            <h5>Other Costs</h5>
            <div v-if="expenses.length">
                <p v-for="i in expenses" :key="i.id">{{ i.label }}: <span class="tf-infoPane__amount">{{ i.value | toCurrency}}</span></p>
            </div>
            <div v-else>
                <p class="tf-infoPane__incomplete">Please complete Step 1.</p>
            </div>

            <div v-if="discount">
              <h5>Discounts</h5>
              <p>{{ discountMsg.title }} <span class="tf-infoPane__amount">- {{ discount | toCurrency }}</span></p>
            </div>

            <h5>Estimate</h5>
            <div class="tf-infoPane__totalMessage" v-html="totalMessage"></div>

            <div v-html="disclaimer" />

<!--            <div class="debug">-->
<!--                <hr>-->
<!--                <p>School ID: <b>{{ schoolId ? schoolId : 'n/a' }}</b></p>-->
<!--            </div>-->

        </div>
    </div>

</template>